import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AppLayout from "../components/AppLayout";
import api from "../services/api";
import { setSession, getUser } from "../lib/auth";

export default function Profile() {
  const { t } = useTranslation();
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ firstname: "", lastname: "", phone: "" });
  const [pwd, setPwd] = useState({ current_password: "", new_password: "" });
  const [msg, setMsg] = useState("");
  const [pwdMsg, setPwdMsg] = useState("");

  useEffect(() => {
    api.get("/api/profile")
      .then((res) => {
        setProfile(res.data);
        setForm({
          firstname: res.data.firstname || "",
          lastname: res.data.lastname || "",
          phone: res.data.phone || "",
        });
      })
      .catch(() => {});
  }, []);

  const saveInfo = async (e) => {
    e.preventDefault();
    setMsg("");
    try {
      await api.put("/api/profile", form);
      setMsg(t("profile.updated"));
      // rafraîchir le nom affiché dans le header
      const u = getUser() || {};
      setSession(null, { ...u, first_name: form.firstname, last_name: form.lastname });
    } catch {
      setMsg(t("profile.updateError"));
    }
  };

  const changePwd = async (e) => {
    e.preventDefault();
    setPwdMsg("");
    try {
      await api.put("/api/profile/password", pwd);
      setPwdMsg(t("profile.passwordChanged"));
      setPwd({ current_password: "", new_password: "" });
    } catch (err) {
      setPwdMsg(err?.response?.data?.message || t("profile.passwordError"));
    }
  };

  const stat = (label, value) => (
    <div className="bg-white rounded-2xl border border-gray-100 p-4 text-center">
      <div className="text-2xl font-bold text-purple-600">{value}</div>
      <div className="text-xs text-gray-500 mt-1">{label}</div>
    </div>
  );

  return (
    <AppLayout title={t("profile.title")}>
      {!profile ? (
        <p className="text-gray-500">{t("common.loading")}</p>
      ) : (
        <div className="space-y-6">
          <div className="grid grid-cols-3 gap-3">
            {stat(t("profile.statFavorites"), profile.stats.favorites)}
            {stat(t("profile.statHistory"), profile.stats.history)}
            {stat(t("profile.statPlaylists"), profile.stats.playlists)}
          </div>

          <form onSubmit={saveInfo} className="bg-white rounded-2xl border border-gray-100 p-6 space-y-4">
            <h2 className="font-semibold text-gray-900">{t("profile.info")}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input className="border rounded-md px-3 py-2" placeholder={t("profile.firstName")}
                value={form.firstname} onChange={(e) => setForm({ ...form, firstname: e.target.value })} />
              <input className="border rounded-md px-3 py-2" placeholder={t("profile.lastName")}
                value={form.lastname} onChange={(e) => setForm({ ...form, lastname: e.target.value })} />
            </div>
            <input className="border rounded-md px-3 py-2 w-full bg-gray-50 text-gray-500" value={profile.email} readOnly />
            <input className="border rounded-md px-3 py-2 w-full" placeholder={t("profile.phone")}
              value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
            <div className="flex items-center gap-3">
              <button className="bg-purple-600 hover:bg-purple-700 text-white px-5 py-2 rounded-md">{t("profile.save")}</button>
              {msg && <span className="text-sm text-green-600">{msg}</span>}
            </div>
          </form>

          <form onSubmit={changePwd} className="bg-white rounded-2xl border border-gray-100 p-6 space-y-4">
            <h2 className="font-semibold text-gray-900">{t("profile.changePassword")}</h2>
            <input type="password" className="border rounded-md px-3 py-2 w-full" placeholder={t("profile.currentPassword")}
              value={pwd.current_password} onChange={(e) => setPwd({ ...pwd, current_password: e.target.value })} required />
            <input type="password" className="border rounded-md px-3 py-2 w-full" placeholder={t("profile.newPassword")}
              value={pwd.new_password} onChange={(e) => setPwd({ ...pwd, new_password: e.target.value })} required minLength={6} />
            <div className="flex items-center gap-3">
              <button className="bg-gray-800 hover:bg-black text-white px-5 py-2 rounded-md">{t("profile.modify")}</button>
              {pwdMsg && <span className="text-sm text-green-600">{pwdMsg}</span>}
            </div>
          </form>
        </div>
      )}
    </AppLayout>
  );
}
